/**
 * Coffee Bean Clicker v2 - Upgrade & Producer Data
 * Pure data only - no logic
 */

// ── Tap Upgrades ──

export interface TapUpgradeDef {
  id: string;
  nameKey: string;
  baseCost: number;
  costMul: number;
  tapPower: number;
  maxLevel: number;
}

export const TAP_UPGRADES: TapUpgradeDef[] = [
  { id: 'T1', nameKey: 'upgrade.T1', baseCost: 10,          costMul: 1.15, tapPower: 1,       maxLevel: 500 },
  { id: 'T2', nameKey: 'upgrade.T2', baseCost: 100,         costMul: 1.15, tapPower: 5,       maxLevel: 400 },
  { id: 'T3', nameKey: 'upgrade.T3', baseCost: 1_000,       costMul: 1.15, tapPower: 25,      maxLevel: 300 },
  { id: 'T4', nameKey: 'upgrade.T4', baseCost: 10_000,      costMul: 1.15, tapPower: 100,     maxLevel: 250 },
  { id: 'T5', nameKey: 'upgrade.T5', baseCost: 100_000,     costMul: 1.15, tapPower: 500,     maxLevel: 200 },
  { id: 'T6', nameKey: 'upgrade.T6', baseCost: 1_000_000,   costMul: 1.15, tapPower: 2_500,   maxLevel: 150 },
  { id: 'T7', nameKey: 'upgrade.T7', baseCost: 10_000_000,  costMul: 1.15, tapPower: 10_000,  maxLevel: 100 },
  { id: 'T8', nameKey: 'upgrade.T8', baseCost: 1_000_000_000, costMul: 1.15, tapPower: 100_000, maxLevel: 50 },
];

// ── Producers (12 tiers) ──

export interface ProducerDef {
  id: string;
  nameKey: string;
  baseCost: number;
  costMul: number;
  baseBPS: number;
  maxCount: number;
  unlockBeans: number;
}

export const PRODUCERS: ProducerDef[] = [
  { id: 'P1',  nameKey: 'producer.P1',  baseCost: 15,                    costMul: 1.15, baseBPS: 0.1,        maxCount: 200, unlockBeans: 0 },
  { id: 'P2',  nameKey: 'producer.P2',  baseCost: 100,                   costMul: 1.15, baseBPS: 1,          maxCount: 200, unlockBeans: 100 },
  { id: 'P3',  nameKey: 'producer.P3',  baseCost: 1_100,                 costMul: 1.15, baseBPS: 8,          maxCount: 200, unlockBeans: 1_000 },
  { id: 'P4',  nameKey: 'producer.P4',  baseCost: 12_000,                costMul: 1.15, baseBPS: 47,         maxCount: 200, unlockBeans: 10_000 },
  { id: 'P5',  nameKey: 'producer.P5',  baseCost: 130_000,               costMul: 1.15, baseBPS: 260,        maxCount: 200, unlockBeans: 100_000 },
  { id: 'P6',  nameKey: 'producer.P6',  baseCost: 1_400_000,             costMul: 1.15, baseBPS: 1_400,      maxCount: 200, unlockBeans: 1_000_000 },
  { id: 'P7',  nameKey: 'producer.P7',  baseCost: 20_000_000,            costMul: 1.15, baseBPS: 7_800,      maxCount: 200, unlockBeans: 10_000_000 },
  { id: 'P8',  nameKey: 'producer.P8',  baseCost: 330_000_000,           costMul: 1.15, baseBPS: 44_000,     maxCount: 200, unlockBeans: 100_000_000 },
  { id: 'P9',  nameKey: 'producer.P9',  baseCost: 5_100_000_000,         costMul: 1.15, baseBPS: 260_000,    maxCount: 200, unlockBeans: 1_000_000_000 },
  { id: 'P10', nameKey: 'producer.P10', baseCost: 75_000_000_000,        costMul: 1.15, baseBPS: 1_600_000,  maxCount: 200, unlockBeans: 10_000_000_000 },
  { id: 'P11', nameKey: 'producer.P11', baseCost: 1_000_000_000_000,     costMul: 1.15, baseBPS: 10_000_000, maxCount: 200, unlockBeans: 100_000_000_000 },
  { id: 'P12', nameKey: 'producer.P12', baseCost: 14_000_000_000_000,    costMul: 1.15, baseBPS: 65_000_000, maxCount: 200, unlockBeans: 1_000_000_000_000 },
];

// ── Milestones ──

export const MILESTONE_THRESHOLDS = [10, 25, 50, 75, 100] as const;
export const MILESTONE_MULTIPLIERS = [2, 2, 2, 2, 10] as const;

// ── Golden Bean Prestige Upgrades (Stage 1) ──

export interface PrestigeUpgradeDef {
  id: string;
  nameKey: string;
  descKey: string;
  cost: number;
  maxLevel: number;
}

export const PRESTIGE_UPGRADES: PrestigeUpgradeDef[] = [
  { id: 'G1',  nameKey: 'prestige.G1',  descKey: 'prestige.G1.desc',  cost: 1,   maxLevel: 1 },
  { id: 'G2',  nameKey: 'prestige.G2',  descKey: 'prestige.G2.desc',  cost: 1,   maxLevel: 1 },
  { id: 'G3',  nameKey: 'prestige.G3',  descKey: 'prestige.G3.desc',  cost: 2,   maxLevel: 1 },
  { id: 'G4',  nameKey: 'prestige.G4',  descKey: 'prestige.G4.desc',  cost: 3,   maxLevel: 1 },
  { id: 'G5',  nameKey: 'prestige.G5',  descKey: 'prestige.G5.desc',  cost: 5,   maxLevel: 1 },
  { id: 'G6',  nameKey: 'prestige.G6',  descKey: 'prestige.G6.desc',  cost: 5,   maxLevel: 1 },
  { id: 'G7',  nameKey: 'prestige.G7',  descKey: 'prestige.G7.desc',  cost: 10,  maxLevel: 1 },
  { id: 'G8',  nameKey: 'prestige.G8',  descKey: 'prestige.G8.desc',  cost: 10,  maxLevel: 1 },
  { id: 'G9',  nameKey: 'prestige.G9',  descKey: 'prestige.G9.desc',  cost: 15,  maxLevel: 1 },
  { id: 'G10', nameKey: 'prestige.G10', descKey: 'prestige.G10.desc', cost: 20,  maxLevel: 1 },
  { id: 'G11', nameKey: 'prestige.G11', descKey: 'prestige.G11.desc', cost: 25,  maxLevel: 1 },
  { id: 'G12', nameKey: 'prestige.G12', descKey: 'prestige.G12.desc', cost: 30,  maxLevel: 1 },
  { id: 'G13', nameKey: 'prestige.G13', descKey: 'prestige.G13.desc', cost: 50,  maxLevel: 1 },
  { id: 'G14', nameKey: 'prestige.G14', descKey: 'prestige.G14.desc', cost: 75,  maxLevel: 1 },
  { id: 'G15', nameKey: 'prestige.G15', descKey: 'prestige.G15.desc', cost: 100, maxLevel: 1 },
  { id: 'G16', nameKey: 'prestige.G16', descKey: 'prestige.G16.desc', cost: 200, maxLevel: 1 },
];

// ── Star Dust Upgrades (Stage 2 Prestige) ──

export interface StarUpgradeDef {
  id: string;
  nameKey: string;
  descKey: string;
  cost: number;
  maxLevel: number;
}

export const STAR_UPGRADES: StarUpgradeDef[] = [
  { id: 'S1', nameKey: 'star.S1', descKey: 'star.S1.desc', cost: 1,  maxLevel: 1 },
  { id: 'S2', nameKey: 'star.S2', descKey: 'star.S2.desc', cost: 2,  maxLevel: 1 },
  { id: 'S3', nameKey: 'star.S3', descKey: 'star.S3.desc', cost: 3,  maxLevel: 1 },
  { id: 'S4', nameKey: 'star.S4', descKey: 'star.S4.desc', cost: 5,  maxLevel: 1 },
  { id: 'S5', nameKey: 'star.S5', descKey: 'star.S5.desc', cost: 8,  maxLevel: 1 },
  { id: 'S6', nameKey: 'star.S6', descKey: 'star.S6.desc', cost: 12, maxLevel: 1 },
  { id: 'S7', nameKey: 'star.S7', descKey: 'star.S7.desc', cost: 20, maxLevel: 1 },
  { id: 'S8', nameKey: 'star.S8', descKey: 'star.S8.desc', cost: 50, maxLevel: 1 },
];

// ── Coffee Varieties ──

export interface VarietyDef {
  id: string;
  nameKey: string;
  unlockType: 'beans' | 'prestige' | 'achievements';
  unlockValue: number;
  bonusType: 'bps' | 'tap' | 'crit' | 'goldenBean' | 'production' | 'finalMul';
  bonusPercent: number;
}

export const VARIETIES: VarietyDef[] = [
  { id: 'V1',  nameKey: 'variety.V1',  unlockType: 'beans',        unlockValue: 0,             bonusType: 'bps',        bonusPercent: 1 },
  { id: 'V2',  nameKey: 'variety.V2',  unlockType: 'beans',        unlockValue: 10_000,        bonusType: 'tap',        bonusPercent: 2 },
  { id: 'V3',  nameKey: 'variety.V3',  unlockType: 'beans',        unlockValue: 500_000,       bonusType: 'bps',        bonusPercent: 3 },
  { id: 'V4',  nameKey: 'variety.V4',  unlockType: 'beans',        unlockValue: 10_000_000,    bonusType: 'crit',       bonusPercent: 1 },
  { id: 'V5',  nameKey: 'variety.V5',  unlockType: 'beans',        unlockValue: 500_000_000,   bonusType: 'bps',        bonusPercent: 5 },
  { id: 'V6',  nameKey: 'variety.V6',  unlockType: 'prestige',     unlockValue: 1,             bonusType: 'goldenBean', bonusPercent: 5 },
  { id: 'V7',  nameKey: 'variety.V7',  unlockType: 'prestige',     unlockValue: 3,             bonusType: 'production', bonusPercent: 10 },
  { id: 'V8',  nameKey: 'variety.V8',  unlockType: 'prestige',     unlockValue: 5,             bonusType: 'tap',        bonusPercent: 15 },
  { id: 'V9',  nameKey: 'variety.V9',  unlockType: 'prestige',     unlockValue: 10,            bonusType: 'bps',        bonusPercent: 20 },
  { id: 'V10', nameKey: 'variety.V10', unlockType: 'achievements', unlockValue: 30,            bonusType: 'production', bonusPercent: 25 },
  { id: 'V11', nameKey: 'variety.V11', unlockType: 'achievements', unlockValue: 50,            bonusType: 'finalMul',   bonusPercent: 20 },
  { id: 'V12', nameKey: 'variety.V12', unlockType: 'prestige',     unlockValue: 20,            bonusType: 'finalMul',   bonusPercent: 50 },
];

// ── Stages ──

export interface StageDef {
  id: number;
  nameKey: string;
  requiredBeans: number;
}

export const STAGES: StageDef[] = [
  { id: 1, nameKey: 'stage.1', requiredBeans: 0 },
  { id: 2, nameKey: 'stage.2', requiredBeans: 1_000 },
  { id: 3, nameKey: 'stage.3', requiredBeans: 50_000 },
  { id: 4, nameKey: 'stage.4', requiredBeans: 1_000_000 },
  { id: 5, nameKey: 'stage.5', requiredBeans: 100_000_000 },
  { id: 6, nameKey: 'stage.6', requiredBeans: 50_000_000_000 },
  { id: 7, nameKey: 'stage.7', requiredBeans: 1_000_000_000_000 },
];

// ── Combo Tiers ──

export interface ComboTierDef {
  minCombo: number;
  multiplier: number;
  labelKey: string;
}

export const COMBO_TIERS: ComboTierDef[] = [
  { minCombo: 50, multiplier: 10,  labelKey: 'combo.legendary' },
  { minCombo: 30, multiplier: 5,   labelKey: 'combo.incredible' },
  { minCombo: 20, multiplier: 3,   labelKey: 'combo.amazing' },
  { minCombo: 10, multiplier: 2,   labelKey: 'combo.great' },
  { minCombo: 5,  multiplier: 1.5, labelKey: 'combo.nice' },
];

// ── Roasting Zones ──

export interface RoastZoneDef {
  min: number;
  max: number;
  multiplier: number;
  labelKey: string;
  isPerfect?: boolean;
}

export const ROAST_ZONES: RoastZoneDef[] = [
  { min: 0.85, max: 0.90, multiplier: 20, labelKey: 'roast.perfect', isPerfect: true },
  { min: 0.70, max: 0.90, multiplier: 10, labelKey: 'roast.dark' },
  { min: 0.50, max: 0.70, multiplier: 5,  labelKey: 'roast.medium' },
  { min: 0.30, max: 0.50, multiplier: 2,  labelKey: 'roast.light' },
  { min: 0.90, max: 1.00, multiplier: 1,  labelKey: 'roast.burnt' },
  { min: 0.00, max: 0.30, multiplier: 1,  labelKey: 'roast.raw' },
];
